import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getAccountsData = (params, headers = {}) =>
  axios.get(`${API_HOST}/accounts`, { params, headers, withCredentials: true });

export const getAccountStatusData = shopId =>
  axios.get(`${API_HOST}/accounts/statuses/${shopId}`, {
    withCredentials: true
  });

export const addAccountData = params =>
  axios.post(`${API_HOST}/accounts/shops/email`, params, {
    withCredentials: true
  });

export const addAccountGroupData = params =>
  axios.post(`${API_HOST}/accounts/groups/email`, params, {
    withCredentials: true
  });

export const addShopAccountData = params =>
  axios.post(`${API_HOST}/accounts/shops`, params, { withCredentials: true });

export const addGroupAccountData = params =>
  axios.post(`${API_HOST}/accounts/groups`, params, { withCredentials: true });

export const addGroupAccountAdminData = params =>
  axios.post(`${API_HOST}/accounts/groupByAdmin`, params, {
    withCredentials: true
  });

export const editAccountEmailData = (manageAccountId, params) =>
  axios.put(`${API_HOST}/accounts/${manageAccountId}/email`, params, {
    withCredentials: true
  });

export const editAccountStatusData = (manageAccountId, params) =>
  axios.put(`${API_HOST}/accounts/${manageAccountId}/status`, params, {
    withCredentials: true
  });
export const getAccountByEmailData = params =>
  axios.get(`${API_HOST}/accounts/accountByEmail`, {
    params,
    withCredentials: true
  });
export const logout = params =>
  axios.post(`${API_HOST}/accounts/logout`, params, {
    withCredentials: true
  });
export const changeAccountEmailData = params =>
  axios.post(`${API_HOST}/accounts/changeEmail`, params, {
    withCredentials: true
  });
export const validateAccountEmailData = params =>
  axios.post(`${API_HOST}/accounts/validateEmail`, params, {
    withCredentials: true
  });
